import React, { PropsWithChildren } from "react"
import { render } from "@testing-library/react"
import type { RenderOptions } from "@testing-library/react"
import type { PreloadedState } from "@reduxjs/toolkit"
import { Provider } from "react-redux"

import { setupStore } from "../app/store"
import type { AppStore, RootState } from "../app/store"

// This type interface extends the default options for render from RTL, as well
// as allows the user to specify other things such as initialState, store.
// ignore the "only use types" eslint rule here, because we are using the
// Omit type to remove the queries property from the RenderOptions type.
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
interface ExtendedRenderOptions extends Omit<RenderOptions, "queries"> {
  preloadedState?: PreloadedState<RootState>
  store?: AppStore
}

export function renderWithProviders(
  ui: React.ReactElement,
  {
    preloadedState = {},
    // Automatically create a store instance if no store was passed in
    store = setupStore(preloadedState),
    ...renderOptions
  }: ExtendedRenderOptions = {},
) {
  function Wrapper({ children }: PropsWithChildren): JSX.Element {
    return <Provider store={store}>{children}</Provider>
  }
  return { store, ...render(ui, { wrapper: Wrapper, ...renderOptions }) }
}

export const fixIcon = <T,>(Icon: T) =>
  Icon as unknown as React.FC<React.SVGProps<SVGSVGElement>>
